import { MRT_Localization, MRT_Localization_EN, MRT_Localization_FR } from '@cmhc-schl/hearth-ui';
import i18n from 'i18next';

export const useMRTCustomTranslation = (totalRows: number) => {
  const locales: Record<string, MRT_Localization> = {
    en: MRT_Localization_EN,
    fr: MRT_Localization_FR
  };

  const currentLocale = locales[i18n.language as 'en' | 'fr'] || MRT_Localization_EN;

  return {
    ...currentLocale,
    noRecordsToDisplay: '',
    selectedCountOfRowCountRowsSelected:
      i18n.language === 'en'
        ? `{selectedCount} of {rowCount} ${totalRows === 1 ? 'row' : 'rows'} selected`
        : '{selectedCount} ligne sur {rowCount} sélectionnée'
  };
};
